// @flow
import React, { Component } from 'react';
import {
  SidebarDeviceBottomDiv,
  SidebarSpacerDiv,
  LogoutButton
} from './SidebarStyles';
import SidebarSecondaryItem from './SidebarSecondaryItem';

type Props = { logout: () => void };

export default class SidebarDeviceBottom extends Component<Props> {
  render() {
    return (
      <>
        <SidebarDeviceBottomDiv>
          <SidebarSpacerDiv />
          <SidebarSecondaryItem to="/account" label="Account" icon="account" />
          <SidebarSecondaryItem
            to="/marketing/sales-materials"
            label="Marketing"
            icon="doc"
          />
          <SidebarSecondaryItem
            to="/support"
            label="Support"
            icon="questionmark"
          />
          <LogoutButton onClick={this.props.logout}>Logout</LogoutButton>
        </SidebarDeviceBottomDiv>
      </>
    );
  }
}
